import React, { useEffect, useState } from "react";
import PlayerDetailsPage from "components/events/playerDetails/playerDetailsPage";
import PlayerVsBullDetailsPage from "components/events/playerDetails/playerVsBullDetails";
import { useAppPerformanceEventsListSelector } from "_common/hooks/selectors/eventSelector";
import { APPLICATION_NAME, CRYPTO_SECRET_KEY } from "_config";
import { useParams } from "react-router";
import Cryptr from 'cryptr';

const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function PlayerDetailsContainer() {


  // const eventDetails = useAppEventDetailsSelector()
  const perfEventsList = useAppPerformanceEventsListSelector()
  const { eventId } = useParams<any>()
  const [currentEvent, setCurrentEvent] = useState<any>()

  useEffect(() => {
    const eId = cryptr.decrypt(eventId)
    const event = perfEventsList?.find((e:any)=>e.id==eId)
    console.log("PlayerDetailsContainer",{event})
    setCurrentEvent(event)

    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Results`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <section className="main-container">
        {currentEvent?.pbr_enable==0 ? <PlayerDetailsPage /> : <PlayerVsBullDetailsPage /> }
      </section>
    </React.Fragment>
  );
}
